// src/main.js
import './axios' // musi być pierwsze (interceptor)
import { createApp, nextTick } from 'vue'
import App from './App.vue'
import router from './router'
import './assets/main.css'
import { translate } from '@/locales/lang'

// ============================================================
// 🔥 TRACKING HELPER – wysyła PageView do GA4 + Meta Pixela
// ============================================================
function trackPageView(to) {
  const path = to?.fullPath || window.location.pathname + window.location.search;
  const title = document.title || 'birdstool.pl';
  const url = window.location.href;

  // --- Google Analytics 4 ---
  if (typeof window.gtag === 'function') {
    window.gtag('event', 'page_view', {
      page_title: title,
      page_path: path,
      page_location: url,
    });
  }

  // --- Meta Pixel ---
  if (typeof window.fbq === 'function') {
    window.fbq('track', 'PageView');
  }
}

// ============================================================
// Tworzenie aplikacji Vue
// ============================================================
const app = createApp(App);

// globalny tłumacz (twoja funkcja)
app.config.globalProperties.$t = translate;

app.use(router);

// ============================================================
// SPA Tracking po zmianie strony
// ============================================================
router.isReady().then(async () => {
  await nextTick();
  trackPageView(router.currentRoute.value); // pierwszy PageView po starcie

  router.afterEach(async (to) => {
    await nextTick();
    trackPageView(to); // kolejne PageView po każdej zmianie
  });

  app.mount('#app');
});
